import Vue from 'vue'
import App from './App'
import axios from 'axios'
import Lockr from 'lockr'
import './api/filter'
import _ from 'lodash'
import router from './router/index.js'
import store from './vuex/store'
import VueRouter from 'vue-router'
import rule from './assets/js/wx-rule.js'
import Qs from 'qs'
import {
  API_HOST,
  API_IMG_HOST,
  CDN_IMG_HOST
} from './api/local'
// import 'ant-design-vue/lib/table/style/css'
import 'ant-design-vue/dist/antd.css'
import './assets/css/base.css'
import './assets/css/new-conmon.css'
import './assets/css/iconfont.css'
import './assets/css/board/iconfont.css'
import './assets/css/now-use-icon/iconfont.css'
import './assets/css/auto-process/iconfont.css'
import './assets/css/second-menu/iconfont.css'
import './assets/css/analyse/iconfont.css'
import _g from './api/global.js'
import echarts from 'echarts'
import 'echarts/lib/chart/map'
import 'echarts/map/js/china.js'
import './assets/css/publicCss.css'
// require styles
import VueQriously from 'vue-qriously'
// 受众菜单图标
import './assets/css/audience_model/iconfont.css'
// element ui
import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
import infiniteScroll from 'vue-infinite-scroll'
Vue.use(infiniteScroll)
import {
  getMember
} from '@/api/customer.js'
// 图片预览
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
Vue.use(preview)
Vue.use(ElementUI)
Vue.use(VueQriously)
// axios.defaults.baseURL = API_HOST
// axios.defaults.timeout = 1000 * 15
// axios.defaults.headers.authKey = Lockr.get('authKey')
// axios.defaults.headers.sessionId = Lockr.get('sessionId')
// axios.defaults.headers['Content-Type'] = 'application/json'
// axios.defaults.paramsSerializer = function (params) {
//   return Qs.stringify(params)
// }
Vue.config.productionTip = false
Vue.prototype.$echarts = echarts
Vue.prototype.$lodash = _
Vue.use(VueRouter)
window.router = router
window.store = store
window.axios = axios
window.Lockr = Lockr
window.rule = rule
window._g = _g
/* eslint-disable no-new */
router.beforeEach((to, from, next) => {
  // console.log(to, to.path, '444444444444')
  // if (
  //   to.path.indexOf('/audiences-manage/') > -1 ||
  //   to.path.indexOf('/tag-list/') > -1
  // ) {
  //   let arr = to.meta.routeArr
  //   arr[0].Rpath = to.path
  //   arr[1].Rpath = to.path
  //   store.state.breadcrumb = to.meta.routeArr
  // }
  // if (to.path === '/home/model-consumer') {
  //   let arr = to.meta.routeArr
  //   arr[0].name = to.query.useName + '管理'
  //   arr[0].Rpath = from.path // + '/' + to.query.modelId
  //   arr[1].name = to.query.useName + '详情'
  //   arr[1].Rpath =
  //     to.path +
  //     '?id=' +
  //     to.query.id +
  //     '&modelId=' +
  //     to.query.modelId +
  //     '&useName=' +
  //     to.query.useName
  //   store.state.breadcrumb = to.meta.routeArr
  // } else {
  //   store.state.breadcrumb = to.meta.routeArr
  // }
  store.state.breadcrumb = to.meta.routeArr
  next()

})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
